module.exports = __webpack_public_path__ + "static/media/atv-flipped.690f3651.png";